import { PersonaMin } from './persona-min';

export class PersonaContacto extends PersonaMin {

  public acudiente: string;
  public acudienteTel: string;
  public acudienteTelMovil: string;
  public allChildAddress: boolean;
  public allChildAcudiente: boolean;
  public telefonoMovil: string;
  public residenciaDireccion: string;
  public residenciaBarrio: string;
  public residenciaTelefono: string;
  public residenciaCiudadID: string;

  constructor (json: any) {
    super(json);
    this.acudiente = json.acudiente || '';
    this.acudienteTel = json.acudienteTel || '';
    this.acudienteTelMovil = json.acudienteTelMovil || '';
    this.allChildAddress = json.allChildAddress;
    this.allChildAcudiente = json.allChildAcudiente;
    this.telefonoMovil = json.telefonoMovil || '';
    this.residenciaDireccion = json.residenciaDireccio || '';
    this.residenciaBarrio = json.residenciaBarrio || '';
    this.residenciaTelefono = json.residenciaTelefono || '';
    this.residenciaCiudadID = json.residenciaCiudadID || -1;
  }
}
